module.exports = __webpack_public_path__ + "img/icons-icon.c66f98fb.svg";